import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ValueDescription } from 'src/app/models/shared/custom-dictionaries';

@Component({
	selector: 'cmv-datalist',
	templateUrl: './datalist.component.html',
	styleUrls: ['./datalist.component.scss'],
})
export class DatalistComponent {
	_sourceList: Array<ValueDescription<number>>;
	@Input() set sourceList(sourceList: Array<ValueDescription<number>>) {
		this._sourceList = sourceList;
		if (this._sourceList.length === 0) {
			this.textFilterInput = '';
		}
	}
	textFilterInput: string;
	textToFilter: string;
	@Input() placeholder: string;
	@Input() inputName: string;
	@Output() selected: EventEmitter<ValueDescription<number>> =
		new EventEmitter();
	optionHasBeenSelected: boolean = false;

	constructor() {}

	get filteredList(): Array<ValueDescription<number>> {
		this.cleanTextFilter();
		return this.isTextToFilterValid
			? this._sourceList.filter(value =>
					value.description
						.toLowerCase()
						.includes(this.textToFilter.toLowerCase())
			  )
			: [];
	}

	get isTextToFilterValid(): boolean {
		return (
			!!this.textToFilter &&
			this.textToFilter !== '' &&
			this.textToFilter !== undefined
		);
	}

	get isFilteredListEmpty(): boolean {
		return this.textToFilter && this.filteredList.length === 0;
	}

	onTextFilterChange(): void {
		this.optionHasBeenSelected = false;
		this.textToFilter = this.textFilterInput;
		this.nofityIfFilteringNoValid();
	}

	onTextFilterFocusOut(): void {
		this.textToFilter = this.textFilterInput;
		setTimeout(() => {
			if (this.filteredList.length > 0 && !this.optionHasBeenSelected) {
				const item = this.filteredList[0];
				this.optionHasBeenSelected = true;
				this.onSelected(item);
			}
		}, 200);
	}

	private nofityIfFilteringNoValid(): void {
		const textToFilterExistsInSourceList = this._sourceList.some(
			value => value.description === this.textToFilter
		);
		if (
			!this.isTextToFilterValid ||
			this.filteredList.length === 0 ||
			!textToFilterExistsInSourceList
		) {
			this.selected.emit(null);
		}
	}

	private cleanTextFilter() {
		const hasSpacesOrAccents = new RegExp(/(^\s|\s$)|[áéíóúÁÉÍÓÚ]/);
		const accentMatcher = new RegExp(/[\u0300-\u036f]/g);
		if (hasSpacesOrAccents.test(this.textToFilter)) {
			this.textToFilter = this.textToFilter.trim();
			this.textToFilter = this.textToFilter
				.normalize('NFD')
				.replace(accentMatcher, '');
		}
	}

	trackByItem(_: number, item: ValueDescription<number>): number {
		return item.value;
	}

	onSelected(item: ValueDescription<number>): void {
		this.textFilterInput = item.description;
		this.optionHasBeenSelected = true;
		this.selected.emit(item);
		this.textToFilter = '';
	}
}
